/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Ikhteacher10Inputs */

const en__field_enum_ikhteacher10 = /** @type {(inputs: _Field_Enum_Ikhteacher10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehrer*in im Schuldienst`)
};

const de__field_enum_ikhteacher10 = /** @type {(inputs: _Field_Enum_Ikhteacher10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehrer*in im Schuldienst`)
};

/**
* | output |
* | --- |
* | "Lehrer*in im Schuldienst" |
*
* @param {_Field_Enum_Ikhteacher10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_ikhteacher10 = /** @type {((inputs?: _Field_Enum_Ikhteacher10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Ikhteacher10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_ikhteacher10(inputs)
	return de__field_enum_ikhteacher10(inputs)
});
export { _field_enum_ikhteacher10 as "_field_enum_IKHTEACHER" }